import { inject, Injectable } from '@angular/core';
import { HttpHandler, HttpEvent, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

//Librerías externas
import { ToastrService } from 'ngx-toastr';

//Servicios
import { TokenReaderService } from '@/app/services/security/token-reader.service';
import { LogoutService } from '@/app/services/security/logout.service';

@Injectable({
  providedIn: 'root'
})
export class RedirectInterceptorService implements HttpInterceptor {
  private sessionExpired = false;
  private toastr = inject(ToastrService);
  private tokenReader = inject(TokenReaderService);
  private logoutService = inject(LogoutService);

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse ) {
          if(err.status === 401){
            this.handleUnauthorized();
          }
        }
        return throwError(() => err);
      })
    );
  }

    private handleUnauthorized(): void {
      if (this.sessionExpired) {
        return;
      }
      this.sessionExpired = true;
      this.tokenReader.clear();
      this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
      setTimeout(() => {
        this.logoutService.cerrarSesion();
      }, 2500);
    }
}
